<template>
    <div :style="avatarStyle" />
</template>

<script>
export default {
    name: 'zoezi-avatar',

    props: {
        size: {
            type: Number,
            default: 24
        },
        color: {
            type: String,
            fulltype: 'color',
            default: 'primary'
        },
        border: {
            type: Boolean,
            default: false
        },
        borderColor: {
            type: String,
            fulltype: 'color',
            default: '#DDDDDD'
        }
    },

    computed: {
        avatarStyle() {
            let style = {};

            if (this.border) {
                style.border = '2px solid ' + this.$root.colorToHex(this.borderColor);
                style.borderRadius = '50%';
            }

            style.width = style.height = this.size + 'px';

            if (this.color) {
                style.backgroundColor = this.$root.colorToHex(this.color);
            }

            return style;
        }
    }
}
</script>
